export const FormSamplesErrorsPageInfo = () => {
    return (
        <>
            You can add your own custom errors, the form below won't submit
            unless a telephone number or email is given.<br />
            <br />
            Use the FormErrors component to display any errors.<br /><br />
            You don't have to use the FormErrors for just custom errors, you can also use it
            to show validation errors on the fields.<br /><br />
            There are different props for the FormErrors component to show different results. You can also:
            <ul>
                <li>Display validation errors. (as mentioned above)</li>
                <li>Include the field names when displaying validation errors.</li>
                <li>Add a general message at the top. Something like 'the following errors have occured:'</li>
                <li>You can display just a general message only, something like 'please fix validation errors' by setting the generalMessage and not setting showFieldValidationErrors.</li>
            </ul>
            See the comments in the code for more information.
        </>
    )
}
